import { IconFont } from '@lighthouse/bui'
import styled from 'styled-components'

export const Container = styled.div``

export const TypeName = styled.div`
    color: var(--color-gray-500);
    font-size: 10px;
    font-weight: var(--font-weight-normal);
    line-height: 20px;
    margin-bottom: 4px;
`

export const FieldItemTitle = styled.div`
    color: var(--color-gray-600);
    font-size: 12px;
    font-weight: 400;
    margin-left: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const FieldItemRightTitle = styled.div`
    color: var(--color-gray-600);
    font-size: 12px;
    white-space: nowrap;
`
